// extracted by mini-css-extract-plugin
module.exports = {"root":"generic-step_root__Ie5DO","header":"generic-step_header___4Yt5","companyCardWrapper":"generic-step_companyCardWrapper__1qBIV","content":"generic-step_content__1Y6sr"};